import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'domSanitize'
})
export class DomSanitize implements PipeTransform {

    constructor(
        private sanitizer: DomSanitizer
    ) { }

    transform(val: any): any {
        const sanitized = this.sanitizer.bypassSecurityTrustHtml(val);
        return sanitized;
    }
}